import React, { useState } from 'react'
import PropTypes from 'prop-types'
import VisibilitySensor from 'react-visibility-sensor'
import {
  MortgageCalculator,
  BuyVsRentCalculator,
  Collapsible,
} from 'Components'

const ListingCalculator = ({
  googleAnalyticsEvent,
  listing,
  collapsibleIdSuffix,
  isForRent,
  user,
}) => {
  if(!listing) return ''
  const [isVisible, setIsVisible] = useState(false)
  const { title, tax, asking_price: price, maintenance_fee: maintenance, mls_number: mls } =
    listing || {}
  return (
    <VisibilitySensor
      onChange={visible => {
        if(visible && !isVisible) {
          setIsVisible(true)
        }
      }}
      partialVisibility
    >
      <Collapsible
        inputId={`Calculator-${collapsibleIdSuffix}`}
        title={isForRent ? 'Rent vs. Buy Calculator' : 'Mortgage Calculator'}
        seoText={
          isForRent
            ? 'View your estimated monthly mortgage and property value affordability.'
            : 'View your estimated monthly mortgage payment based on interest rates from our partner.'
        }
        gaActionTitle="Calculator"
        defaultShowState
      >
        {isVisible ? (
          isForRent ? (
            <BuyVsRentCalculator
              address={title}
              rent={price}
              googleAnalyticsEvent={googleAnalyticsEvent}
              user={user}
              listingId={listing.id}
              mls={mls}
              collapsibleIdSuffix={collapsibleIdSuffix}
            />
          ) : (
            <MortgageCalculator
              address={title}
              googleAnalyticsEvent={googleAnalyticsEvent}
              price={price}
              maintenance={maintenance}
              tax={tax}
              user={user}
              listingId={listing.id}
              mls={mls}
              collapsibleIdSuffix={collapsibleIdSuffix}
            />
          )
        ) : null}
      </Collapsible>
    </VisibilitySensor>
  )
}

ListingCalculator.propTypes = {
  listing: PropTypes.shape({
    id: PropTypes.number,
    tax: PropTypes.number,
    title: PropTypes.string,
    listing_estimate: PropTypes.shape({}),
    asking_price: PropTypes.number,
    address: PropTypes.shape({
      lat: PropTypes.string,
      lng: PropTypes.string,
    }),
  }),
  googleAnalyticsEvent: PropTypes.func,
  collapsibleIdSuffix: PropTypes.string,
  places: PropTypes.shape({}),
  navigationLinks: PropTypes.shape({}),
  isForRent: PropTypes.bool,
  user: PropTypes.shape({}),
}

export default ListingCalculator
